<div class="slider-block">
  <div class="bg-graph" [ngStyle]="this.min < 0 && this.max > 0 ? {'width': zeroPoint} : {}"></div>

  <div class="leftBracket"></div>
  <div class="rightBracket"></div>


  <div class="slide-over">
    <div class="left-over">Bid</div>
    <div class="right-over">Offer</div>
    <span class="relative-top">{{getCostLabel() | translate}}</span>
    <span class="relative-top-right">{{getEarningLabel() | translate}}</span>
  </div>


  <div class="slidecontainer">

      <span class="beforeBracket">
      <input [(ngModel)]="value" value="0" type="range" list="tickmarks" [ngClass]="setClasses()" (ngModelChange)="showAndPropagateSliderValue()" #myRange max="{{max}}" min="{{min}}" [step]="trade.sixLetterCode.includes('JPY') ? 1 : 0.01">
        </span>

    <div *ngIf="this.min < 0 && this.max > 0" class="tick" [ngStyle]="{'margin-left': zeroPoint}"></div>

    <span class="rs-label" #myValue>{{value | number:'1.0'}}</span>

    <datalist id="tickmarks" *ngIf="this.min < 0 && this.max > 0">
      <option value="0">
    </datalist>

  </div>

  <div class="slide-under">
    <div class="left-under">{{min | number:'1.0'}}</div>
    <div class="right-under">{{max | number:'1.0'}}</div>
  </div>
</div>



